import { CSSProperties } from 'react';
import { Theme } from '@mui/material';

export const searchBarStyles = (theme: Theme, isFullWidth?: boolean) => ({
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	fieldWrapper: {
		width: isFullWidth ? '100%' : 'auto',
	},
	textField: {
		minWidth: '8rem',

		'& .MuiInputBase-root': {
			'& .MuiInputAdornment-root': {
				width: '18px',
				height: '18px',
				mr: 0,

				'& >svg': {
					color: 'rgba(250, 250, 250, 0.7)',
				}
			},

			'& .MuiInput-input': {
				fontFamily: 'Integral CF',
				fontWeight: '500',
				fontSize: '14px',
				color: '#FFFFFF',
				lineHeight: '15px',
				textTransform: 'uppercase',

				'&::placeholder': {
					opacity: 1,
					fontFamily: 'Integral CF',
					fontWeight: '500',
					fontSize: '14px',
					lineHeight: '15px',
					textTransform: 'uppercase',
					color: 'rgba(250, 250, 250, 0.7)',
				},
			},

			'&:hover': {
				"&::before": {
					borderBottom: '1px solid rgba(250, 250, 250, 0.7)',
				}
			},

			'&::before': {
				borderBottom: '1px solid rgba(250, 250, 250, 0.7)',
			},

			'&::after': {
				borderBottom: '1px solid #FFFFFF',
			}
		},
	},
	inputStyles: {
		padding: '6px 4px',
		height: '15px',
	} as CSSProperties,
});
